import View from './View';

export { default as View, getSettingsLanguageStyles } from './View';

export default View;
